import { postData } from './fetch';
import { clearErrors, handleErrors } from './handle-error';
import { mask } from './helpers';

window.addEventListener('load', () => {
  const vacanciesSwiper = document.querySelector('.vacancies-swiper');
  const showVacanciesListBtn = document.querySelector('.show-vacancies-list');
  const showCitiesListBtn = document.querySelector('.show-cities-list');
  const vacanciesButtons = document.querySelectorAll('.vacancy-button');
  const citiesButtons = document.querySelectorAll('.city-button');
  const vacancyWrapper = document.querySelector('.vacancy-wrapper');
  const citiesWrapper = document.querySelector('.cities-wrapper');
  const vacancyHiddenInput = document.querySelector('.vacancy-hidden-input');
  const lastNameInput = document.querySelector('.last-name');
  const firstNameInput = document.querySelector('.first-name');
  const cityHiddenInput = document.querySelector('.city-hidden-input');
  const birthdayPicker = document.querySelector('.birtday-input');
  const birthdayText = document.querySelector('.birthday-text');
  const careerPhoneInput = document.querySelector('.career-phone-input');
  const emailInput = document.querySelector('.email-input');
  const emailInputWrapper = document.querySelector('.email-wrapper');
  const fileInput = document.querySelector('.file-input');
  const resumeFileName = document.querySelector('.resume-text');
  const careerSuccessPopupWrapper = document.querySelector(
    '.career-success-popup-wrapper',
  );
  const careerPopupWrapper = document.querySelector('.career-popup-wrapper');
  const careerForm = document.querySelector('.career-form');
  const formGroups = document.querySelectorAll('.form-group');
  const submitBtn = document.querySelector('.career-form .submit');
  const commentInput = document.querySelector('.career-form .comment-input');
  const commentInputWrapper = careerForm.querySelector(
    '.form-group:has(textarea[name="comment"])',
  );
  const phoneInputWrapper = careerForm.querySelector(
    '.form-group:has(input[name="phone"])',
  );
  const resumeLinkInput = document.querySelector('.resume-link');

  const user = {
    phone: careerPhoneInput.getAttribute('data-phone'),
    birthday: birthdayPicker.getAttribute('data-birthday'),
    city: {
      cityName: showCitiesListBtn.getAttribute('data-name'),
      cityId: showCitiesListBtn.getAttribute('data-id'),
    },
  };

  let date = new Date(Date.now());

  const isPhoneValid = (phoneValue) => {
    const digits = phoneValue.replace(/\D/g, '').slice(1);
    return digits.length === 10;
  };

  const isEmailValid = (emailValue) => {
    return /.+@.+\..+/gi.test(emailValue);
  };

  const validateForm = () => {
    const isFormValid = Boolean(
        isEmailValid(emailInput.value) &&
        vacancyHiddenInput.value &&
        lastNameInput.value &&
        firstNameInput.value &&
        birthdayPicker.value &&
        isPhoneValid(careerPhoneInput.value) &&
        cityHiddenInput.value,
    );
    submitBtn.toggleAttribute('disabled', !isFormValid);
  };

  const handleBirthdayDate =(value) =>{
    date = new Date(value);

    const day = date.getDate();
    const month = months[date.getMonth()];
    const year = date.getFullYear();

    if (birthdayText.classList.contains('gray-text')) 
      birthdayText.classList.remove('gray-text');

    birthdayText.textContent = `${day} ${month} ${year}`;
  }

  const handleBirthdayPicker = (value) => {
    const day = value.getDate();
    const month = months[value.getMonth()];
    const year = value.getFullYear();
    birthdayText.textContent = `${day} ${month} ${year}`;
  };

  if (vacanciesSwiper) {
    new Swiper('.vacancies-swiper', {
      slidesPerView: 1,
      spaceBetween: 31,
      breakpoints: {
        500: {
          slidesPerView: 2,
        },
        768: {
          slidesPerView: 3,
        },
        850: {
          slidesPerView: 3.1,
        },
        1181: {
          slidesPerView: 4.1,
        },
        1441: {
          slidesPerView: 5.1,
        },
      },
      pagination: {
        el: '.swiper-pagination',
        clickable: true,
        dynamicBullets: true,
      },
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
      },
    });
  }

  if (showVacanciesListBtn) {
    showVacanciesListBtn.addEventListener('click', () => {
      if (vacancyWrapper && vacancyWrapper.classList.contains('opened')) {
        vacancyWrapper.classList.remove('opened');
      } else {
        vacancyWrapper.classList.add('opened');
      }
    });
  }

  if (vacanciesButtons) {
    [].forEach.call(vacanciesButtons, (btn) => {
      btn.addEventListener('click', () => {
        [].forEach.call(vacanciesButtons, (button) =>
          button.classList.remove('active'),
        );

        btn.classList.add('active');
        showVacanciesListBtn.innerHTML = btn.innerHTML;

        if (vacancyWrapper) {
          vacancyWrapper.classList.add('focused');
        }

        vacancyWrapper.classList.remove('opened');

        if (vacancyHiddenInput) {
          vacancyHiddenInput.value = btn.innerHTML;
        }
        validateForm();
      });
    });
  }

  if (showCitiesListBtn) {
    showCitiesListBtn.addEventListener('click', () => {
      if (citiesWrapper && citiesWrapper.classList.contains('opened')) {
        citiesWrapper.classList.remove('opened');
      } else {
        citiesWrapper.classList.add('opened');
      }
    });
  }

  if (citiesButtons) {
    [].forEach.call(citiesButtons, (btn) => {
      btn.addEventListener('click', () => {
        [].forEach.call(citiesButtons, (button) =>
          button.classList.remove('active'),
        );

        btn.classList.add('active');
        showCitiesListBtn.innerHTML = btn.innerHTML;

        if (citiesWrapper) {
          citiesWrapper.classList.add('focused');
        }

        citiesWrapper.classList.remove('opened');

        if (cityHiddenInput) {
          cityHiddenInput.value = btn.dataset.id;
        }
        validateForm();
      });
    });
  }

  const months = [
    'Января',
    'Февраля',
    'Марта',
    'Апреля',
    'Мая',
    'Июня',
    'Июля',
    'Августа',
    'Сентября',
    'Октября',
    'Ноября',
    'Декабря',
  ];

  if (birthdayPicker) {
    pickmeup.defaults.locales['ru'] = {
      days: [
        'Воскресенье',
        'Понедельник',
        'Вторник',
        'Среда',
        'Четверг',
        'Пятница',
        'Суббота',
      ],
      daysShort: ['Вс', 'Пн', 'Вт', 'Ср', 'Чт', 'Пт', 'Сб'],
      daysMin: ['Вс', 'Пн', 'Вт', 'Ср', 'Чт', 'Пт', 'Сб'],
      months: [
        'Январь',
        'Февраль',
        'Март',
        'Апрель',
        'Май',
        'Июнь',
        'Июль',
        'Август',
        'Сентябрь',
        'Октябрь',
        'Ноябрь',
        'Декабрь',
      ],
      monthsShort: [
        'Янв',
        'Фев',
        'Мар',
        'Апр',
        'Май',
        'Июн',
        'Июл',
        'Авг',
        'Сен',
        'Окт',
        'Ноя',
        'Дек',
      ],
    };

    if (birthdayPicker.value) handleBirthdayDate(birthdayPicker.value);

    pickmeup('.birtday-input', {
      format: 'Y-m-d',
      locale: 'ru',
      date,
      hide_on_select: true,
      title_format: 'B',
      default_date: false,
    });

    birthdayPicker.addEventListener('pickmeup-change', (e) => {
      handleBirthdayPicker(e.detail.date);
      birthdayText.classList.add('visible');
      birthdayPicker.classList.add('with-value');

      if (birthdayText.classList.contains('gray-text')) {
        birthdayText.classList.remove('gray-text');
      }
      validateForm();
    });
  }

  if (emailInput) {
    emailInput.addEventListener('input', (e) => {
      if (emailInputWrapper){
        isEmailValid(e.target.value) ? 
            emailInputWrapper.classList.remove('error') :
            emailInputWrapper.classList.add('error');
        }

        validateForm();
    });
  }

  if (fileInput) {
    fileInput.addEventListener('input', () => {
      if (resumeFileName) {
        resumeFileName.innerHTML = fileInput.files[0].name;

        resumeFileName.classList.remove('grey-color');
      }
      validateForm();
    });
  }

  if (careerPhoneInput) {
    if (careerPhoneInput.value) {
      mask(careerPhoneInput, '+7 ___ ___ __ __');
    }

    ['input', 'focus', 'blur', 'change'].forEach((event) => {
      careerPhoneInput.addEventListener(event, () => {
        mask(careerPhoneInput, '+7 ___ ___ __ __');
        validateForm();
      });
    });
  }

  if (fileInput) {
    fileInput.addEventListener('change', async () => {
      const parentElement = fileInput.querySelector('.resume-wrapper');

      submitBtn.value = 'Загрузка...';
      submitBtn.setAttribute('disabled', 'disabled');

      if (parentElement) {
        parentElement.classList.add('disabled');
      }

      const formData = new FormData();
      formData.append('file', fileInput.files[0], fileInput.files[0].name);

      const fileUpload = await fetch('/uploads', {
        method: 'POST',
        headers: {
          Accept: 'application/json',
        },
        body: formData,
      });

      if (fileUpload) {
        const fileData = await fileUpload.json();
        submitBtn.value = 'Отправить анкету';

        if (resumeLinkInput) {
          resumeLinkInput.value = fileData.data.file.location;
        }
      } else {
      }
    });
  }

  if (careerForm) {
    const textInput = careerForm.querySelectorAll('.text-input');

    if (textInput) {
      [].forEach.call(textInput, (input) => {
        input.addEventListener('input', (e) => {
          input.value = e.target.value.replace(/[^a-zA-Zа-яА-Я - ё]/g, '');
          validateForm();
        });
      });
    }

    careerForm.addEventListener('submit', async (e) => {
      clearErrors();
      e.preventDefault();

      const nextDate = new Date(birthdayPicker.value);

      const day = `${nextDate.getDate() < 10 ? '0' : ''}${nextDate.getDate()}`;
      const month = `${nextDate.getMonth() + 1 < 10 ? '0' : ''}${
        nextDate.getMonth() + 1
      }`;

      const body = {
        firstName: firstNameInput.value,
        lastName: lastNameInput.value,
        position: vacancyHiddenInput.value,
        cityId: cityHiddenInput.value,
        email: emailInput.value,
        phone: `${careerPhoneInput.value
          .replace(' ', '')
          .replace(' ', '')
          .replace(' ', '')
          .replace(' ', '')}`,
        birthday: `${nextDate.getUTCFullYear()}-${month}-${day}`,
      };

      if (commentInput.value) {
        body.additional = commentInput.value;
      }

      if (resumeLinkInput.value) {
        body.resume = resumeLinkInput.value;
      }
      
      submitBtn.value = 'Загрузка...';
      submitBtn.setAttribute('disabled', 'disabled');

      const response = await postData('/career/apply', body);

      if (response) {
        if (response.statusCode === 200) {
          if (careerPopupWrapper) {
            careerPopupWrapper.classList.remove('active');
          }

          if (careerSuccessPopupWrapper) {
            careerSuccessPopupWrapper.classList.add('active');
            careerForm.reset();

            submitBtn.value = 'Отправить анкету';

            if (showVacanciesListBtn) {
              showVacanciesListBtn.textContent = '';
            }

            if (vacancyWrapper) {
              vacancyWrapper.classList.remove('focused');
            }

            if (vacancyHiddenInput) {
              vacancyHiddenInput.value = '';
            }

            if (showCitiesListBtn) {
              if (user.city.cityName) {
                showCitiesListBtn.textContent = user.city.cityName;
                citiesWrapper.classList.add('focused');
              } else{
                showCitiesListBtn.textContent = '';
                citiesWrapper.classList.remove('focused');
              }
            }

            if (cityHiddenInput) {
              cityHiddenInput.value = user.city.cityId || '';
            }

            // if (emailInput){
            //   emailInput.value = '';
            // }

            if (birthdayText) {
              if (user.birthday) handleBirthdayDate(user.birthday);
              else {
                birthdayText.textContent = 'Дата рождения*';
                birthdayText.classList.add('gray-text');
              };
            }

            if (birthdayPicker) {
              if (user.birthday) handleBirthdayPicker(new Date(user.birthday));
              
              else {
                birthdayPicker.value = '';
                birthdayPicker.setAttribute('placeholder', 'Дата рождения*');
                birthdayPicker.classList.remove('with-value');
              }
            }

            if (careerPhoneInput) {
                careerPhoneInput.value = user.phone;
                if (user.phone) mask(careerPhoneInput, '+7 ___ ___ __ __');
            }

            if (resumeFileName) {
              resumeFileName.textContent = 'Загрузите резюме';
              resumeFileName.classList.add('grey-color');
            }

            if (formGroups) {
              [].forEach.call(formGroups, (item) => {
                item.classList.remove('focused');

                const placeholder = item.querySelector('.placeholder');
                const input = item.querySelector('input');
                const textarea = item.querySelector('textarea');

                if (placeholder && placeholder.innerHTML) {
                  if (input) {
                    input.setAttribute('placeholder', placeholder.innerHTML);
                  }

                  if (textarea) {
                    textarea.setAttribute('placeholder', placeholder.innerHTML);
                  }
                }
              });
            }
          }
        } else {
          submitBtn.value = 'Отправить анкету';
          submitBtn.removeAttribute('disabled');

          handleErrors(response.errors.position, vacancyWrapper);

          handleErrors(response.errors.phone, phoneInputWrapper);

          handleErrors(response.errors.email, emailInputWrapper);

          handleErrors(response.errors.additional, commentInputWrapper);
        }
      }
    });
  }
});
